var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPayments = function SvgPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 7.5 2 3.4v2.2l-2 3.4v-9Z",
    fill: "#5B57A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13 9.7 2-1.1h4L13 12V9.7Z",
    fill: "#D90751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5V12L11 11V4l2 3.5Z",
    fill: "#FAB718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.6h-4l-2-1.1L11 4l8 4.6Z",
    fill: "#ED6F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5v-2.2l-2-1.2V20l2-3.5Z",
    fill: "#63B22F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.4 7 11 5 7.5l14 8h-4Z",
    fill: "#1487C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m11 20 2-3.5 2-1h4L11 20Z",
    fill: "#017F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m5 16.5 6-3.4L9 12l-2 1-2 3.5Z",
    fill: "#984995"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3 7.2 47 16.8h2.3l1.4-9.6h-2.3Zm-3.3 0-2.2 6.6-.3-1.4V12a8 8 0 0 0-3-3.6l2 8.3h2.3l3.6-9.6H45Zm8.9 2.7c0-1.1 2.2-1 3.2-.4l.3-2s-1-.5-2-.5c-1.2 0-3.9.5-3.9 3.2 0 2.5 3.2 2.5 3.2 3.8 0 1.3-2.9 1.1-3.8.3l-.3 2.2s1 .5 2.5.5c1.6 0 4-.9 4-3.3 0-2.5-3.2-2.8-3.2-3.8Zm9.3-2.7h-1.9c-.8 0-1 .7-1 .7l-3.4 9h2.4l.4-1.5h3l.2 1.4H65l-1.8-9.6Zm-2.8 6.2 1.2-3.6.7 3.6h-1.9Z",
    fill: "#1C33C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8 8s0-.8-1.1-.8H37v.2s1.8.4 3.4 1.9a7.6 7.6 0 0 1 2.2 3.1l-.8-4.3Z",
    fill: "#1C33C3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8 16.1V16l-.1.1V16h-.1v.2-.2.2h.1v-.2.2h.1Zm-.4 0V16h-.1v.2h.1Z",
    fill: "#00A2E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 17.2h-5.4V7.3h5.4v9.9Z",
    fill: "#FF5F00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6 12.3c0-2 1-3.8 2.4-5a6.2 6.2 0 0 0-10 5c0 3.4 2.8 6.2 6.2 6.2 1.4 0 2.8-.5 3.8-1.3a6.3 6.3 0 0 1-2.4-5Z",
    fill: "#EB001B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100 12.3c0 3.4-2.8 6.2-6.2 6.2-1.4 0-2.8-.5-3.8-1.3a6.3 6.3 0 0 0 0-9.9 6.2 6.2 0 0 1 10 5Z",
    fill: "#F79E1B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135 11.8V16h2.5v-2.4h2.5a3 3 0 0 0 2.9-1.8h-8Z",
    fill: "#064"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m134.8 8 .1.6v.2c.3.7.7 1.4 1.3 1.8.6.5 1.4.7 2.1.7h4.7v-.5c0-.7-.3-1.4-.8-2-.5-.5-1.2-.8-2-.8h-5.4Z",
    fill: "url(#a)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m130.5 8.8-1.8 4h-.1V8H126v8h2a1.4 1.4 0 0 0 1.4-.8l1.7-4h.2V16h2.5V8h-2.1c-.3 0-.6 0-.8.2l-.5.6ZM118.9 9l1 3.7h.2l1-3.6c.1-.4.3-.6.5-.8l.9-.3h2.5v8h-2.5v-4.7h-.2L121 16H119l-1.4-4.7h-.2V16H115V8h2.5l.9.3c.2.2.4.4.5.8Z",
    fill: "#064"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 115,
    y1: 12,
    x2: 143,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3E91"
  })))));
};
export default SvgPayments;